import { useParams } from 'react-router-dom'
import { useHubStore } from '@renderer/stores/hubStore'
import { getHomePath, getRouteBasePath } from '@renderer/utils/navigationUtils'

/**
 * The route to navigate to when a session ends or a guard bounces: the hub
 * Welcome when this project was entered from a hub, else this project's own
 * Welcome. Uses the raw route param so digital-mode slugs survive.
 *
 * On a hub route itself (`/hub/:hubId`) there is no `:projectId`, so home is
 * the hub — without this a deep-link into a hub sub-path would bounce the
 * operator all the way out to the Projects list.
 */
export function useHomePath(): string {
  const { projectId: routeParam, hubId } = useParams()
  const hubContextId = useHubStore((s) => s.hubId)
  const memberProjectId = useHubStore((s) => s.memberProjectId)
  const returnTo = useHubStore((s) => s.returnTo)
  if (hubId) return getRouteBasePath({ hubId })
  return getHomePath(routeParam, { hubId: hubContextId, memberProjectId, returnTo })
}
